// src/api/workflowAPI.js

// 后端API的基础URL
// const API_BASE_URL = "http://localhost:10045/assembleLog";
const API_BASE_URL = "https://www.assemble.chip-nova.cn/assemble/assembleLog";
// 从环境变量或配置文件获取更佳
const AUTH_TOKEN =
  "sk_live_5A$b8X@k3P#m6R9tQ2vS7uY4wZ1cD0eF5gH6jK7lM8nO9pQ0rS2tU4vW6xY8z";

/**
 * 通用的API调用函数
 * @param {string} endpoint - 请求的API端点 (例如 'validate-shell')
 * @param {object} payload - 发送到后端的数据
 * @returns {Promise<{success: boolean, data: any, message: string}>}
 */
const apiCall = async (endpoint, payload) => {
  try {
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Auth-Token": AUTH_TOKEN, // 添加鉴权Token
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json(); // 后端返回 AjaxResult 格式
    if (!response.ok || result.code !== 200) {
      console.error(
        `API Error on ${endpoint}:`,
        result.msg || response.statusText
      );
      // 返回一个标准的失败结构，其中 message 来自后端
      return { success: false, data: null, message: result.msg || "请求失败" };
    }

    // 返回一个标准的成功结构
    return { success: true, data: result.data, message: result.msg };
  } catch (error) {
    console.error(`Network Error on ${endpoint}:`, error);
    // 网络层面的错误
    return {
      success: false,
      data: null,
      message: "网络连接失败，请检查网络后重试",
    };
  }
};

// --- 灌胶流程相关API ---
export const pottingAPI = {
  /**
   * 校验外壳二维码
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  validateDeviceByShell: (data) => apiCall("validate-shell", data),
  /**
   * 校验板子二维码
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  validateDeviceByBoard: (data) => apiCall("validate-board", data),
  /**
   * 保存灌胶流程最终状态
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  saveState: (data) => apiCall("save", data),
};

// --- 焊接流程相关API ---
export const weldingAPI = {
  /**
   * 校验外壳二维码
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  validateDevice: (data) => apiCall("validate-shell", data),
  /**
   * 检查设备上电后的状态
   * @param {object} data - { deviceId, operation, seriesId, content: null }
   */
  checkUploadStatus: (data) => apiCall("systemCheck", data),
  /**
   * 保存焊接流程最终状态
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  saveState: (data) => apiCall("save", data),
};

// --- 绑定流程相关API ---
export const bindingAPI = {
  /**
   * 校验外壳二维码
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  validateShellCode: (data) => apiCall("validate-shell", data),
  /**
   * 校验左侧标签
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  validateLeftTab: (data) => apiCall("scanLeftTab", data),
  /**
   * 校验右侧标签
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  validateRightTab: (data) => apiCall("scanRightTab", data),
  /**
   * 保存绑定流程最终状态
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  saveState: (data) => apiCall("save", data),
};

// --- 最终检查流程相关API ---
export const finalCheckAPI = {
  /**
   * 校验外壳二维码
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  validateDevice: (data) => apiCall("check/validate-device", data),
  /**
   * 检查设备上电后的状态
   * @param {object} data - { deviceId, operation, seriesId, content: null }
   */
  finalCheck: (data) => apiCall("check/final", data),
  /**
   * 保存流程最终状态
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  saveState: (data) => apiCall("check/save", data),
};

// --- 内部抽检流程相关API ---
export const innerSamplingAPI = {
  /**
   * 校验外壳二维码
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  validateDevice: (data) => apiCall("check/validate-device", data),
  /**
   * 校验左侧标签
   * @param {object} data - { deviceId, operation, seriesId, content: null }
   */
  validateLeftTab: (data) => apiCall("check/validate-left-tab", data),
  /**
   * 校验右侧标签
   * @param {object} data - { deviceId, operation, seriesId, content: null }
   */
  validateRightTab: (data) => apiCall("check/validate-right-tab", data),
  /**
   * 保存流程最终状态
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  saveState: (data) => apiCall("check/save", data),
};

// --- 设备状态流程相关API ---
export const checkStatusAPI = {
  /**
   * 获取设备状态
   * @param {object} data - { deviceId, operation, seriesId, content }
   */
  checkStatus: (data) => apiCall("check/status", data),
};

// --- 通用异常上报API ---
/**
 * 上报异常信息
 * @param {object} errorInfo - { deviceId, operation, seriesId, extraData }
 */
export const reportExceptionAPI = (errorInfo) =>
  apiCall("uploadError", errorInfo);
